import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Reactportal from "../../Components/Reactportal/Reactportal";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import "./FastTagDetails.scss";
import { useModalContext } from "../../Components/Reactportal/ModalContext";
import Input from "../../Components/Input/Input";
import Button from "../../Components/Button/Button";
import axios from "axios";
import { WarningToast } from "../../Components/ToastComponent/RectHotToast";

const FastTagDetails = ({ TypeOfPortal = "Fast Tag Details" }) => {
  const Form_Key = "Report_Setup";
  const [toggle, setToggle] = useState(false);
  const [SearchValue, setSearchvalue] = useState("");
  const [apiResponse, setApiResponse] = useState(null); // To store API response
  const [loading, setLoading] = useState(false); // To handle loading state
  const [error, setError] = useState(null); // To handle error state

  const { pushModal, popModal, getTopModal } = useModalContext();
  const navigate = useNavigate();

  const HandleApicallButoon = async () => {
    console.log("Api call button is triggered");
    if (!SearchValue) {
      WarningToast("Please enter a vehicle number to search.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(`${process.env.REACT_APP_CUSTOMER_SITE_BACKEND}/fastagdata`, {
        vehiclenumber: SearchValue,
      });
      setApiResponse(response.data);
      console.log("API Response:", response.data);
    } catch (err) {
      setError("Failed to fetch vehicle data. Please try again.");
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleItemSearch = (event) => {
    setSearchvalue(event?.target?.value.toUpperCase());
  };

  const closeFormFunction = () => {

    setToggle(false);
  };

  useEffect(() => {
    setToggle(true);
  }, []);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      handleformclose={() => {
        closeFormFunction();
        setToggle(!toggle);
      }}
    />
  );

  return (
    <div>
      <Reactportal FoooterContent={footerContent} open={toggle} onClose={closeFormFunction} TypeOfPortal={TypeOfPortal}>
        <div className="FastTagDetails-container ">
          <div className="fasttag-input">
            <div className={`form__group field apiButtonInput`}>
              <input
                className="form__field"
                type="search"
                value={SearchValue}
                onChange={handleItemSearch}
                style={{ flex: 1 }}
                placeholder="Enter Vehicle Number"
                width={200}
              />
              <label className="form__label textAreaLabel" style={{ marginTop: "1px" }}>
                Search By Vehicle No
              </label>
              <div className="api-button-container">
                <Button
                  type="button"
                  className="api-button"
                  text={loading ? "Loading..." : "GO"}
                  name="api-button"
                  action={HandleApicallButoon}
                  disabled={loading}
                />
              </div>
            </div>
          </div>
          {/* Display API Response or Error */}
          <div className="FastTagDetails-api-response">
            {error && <div className="error">{error}</div>}
            {apiResponse?.responseFasttagType && (
              <div className="response">
                <h4>response FasttagType</h4>
                <pre>{JSON.stringify(apiResponse?.responseFasttagType, null, 2)}</pre>
              </div>
            )}
            {apiResponse?.responseLocation && (
              <div className="response">
                <h4>response Location</h4>
                <pre className="FastTagDetails-api-response-pre">
                  {JSON.stringify(apiResponse?.responseLocation, null, 2)}
                </pre>
              </div>
            )}
          </div>
        </div>
      </Reactportal>
    </div>
  );
};

export default FastTagDetails;
